<template>
  <div>
    <div>
      <label class="text-white mb-4 flex items-start gap-x-2">
        <input
          type="checkbox"
          name="confirm_data"
          id="confirm_data"
          v-model="confirmData"
        >
        I confirm that the data on the card I am about to submit matches my registration data.
      </label>
      <br />
      <a
        v-if="confirmData"
        @click="sendRequest"
        class="button is-success"
      >
        {{ $t("deposit").tUpper() }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ['apm', 'payment_data'],
  data() {
    return {
      confirmData: false,
    }
  },
  mounted() {},
  methods: {
    sendRequest() {
      this.$emit('request')
    },
  },
}
</script>



// WEBPACK FOOTER //
// mulix-visa.vue?8416f986